module.exports = __webpack_public_path__ + "static/media/team-5.d67d947d.jpg";